export var ActionMessageType;
(function (ActionMessageType) {
    ActionMessageType["ConfirmTransaction"] = "ConfirmTransaction";
    ActionMessageType["TransactionInProgress"] = "TransactionInProgress";
    ActionMessageType["InsufficientFunds"] = "InsufficientFunds";
    ActionMessageType["TransactionRejected"] = "TransactionRejected";
    ActionMessageType["WaletMismatch"] = "WaletMismatch";
    ActionMessageType["TransactionFailed"] = "TransactionFailed";
    ActionMessageType["TransactionExpired"] = "TransactionExpired";
    ActionMessageType["UnexpectedErrorMessage"] = "UnexpectedErrorMessage";
    ActionMessageType["DifferentAccountsNotAllowedError"] = "DifferentAccountsNotAllowedError";
})(ActionMessageType || (ActionMessageType = {}));
